import { exportMiembro } from '../../api/miembros/exportMiembro';
import { downloadFileFromContent } from '../../helpers/redirects/downloadFileFromContent';
import createApiModule from '../createApiModule';
import { t } from '../../i18n';

const exportMiembrosModule = createApiModule({
  name: 'exportMiembros',
  apiMethod: exportMiembro,
  onSuccess: (data) =>
    downloadFileFromContent(
      data.content,
      'miembros.csv',
      'text/csv;charset=utf-8;',
    ),
  onError: () => ({
    message: t('StoreMiembrosExportMiembrosModuleErrorExportandoLosMiembros'),
  }),
  onValidationError: () => ({
    message: t('StoreMiembrosExportMiembrosModuleErrorExportandoLosMiembros'),
  }),
});

export const {
  start: exportMiembros,
  success: exportMiembrosOk,
  error: exportMiembrosKo,
} = exportMiembrosModule.slice.actions;

export default exportMiembrosModule;
